// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2pZtg","inner":"Footer_inner__1PUcE"};